import { TExperiments } from '../../types/experiments';
import { IApplicationState } from '../../types/redux';

export const selectExperiments = (state: IApplicationState): TExperiments => state.experiments;
